import React from 'react';

export const ActivateArtIcon = (props) => {
    return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 6.75C10.6575 6.75 12 5.4075 12 3.75C12 2.0925 10.6575 0.75 9 0.75C7.3425 0.75 6 2.0925 6 3.75C6 5.4075 7.3425 6.75 9 6.75ZM9 2.25C9.825 2.25 10.5 2.925 10.5 3.75C10.5 4.575 9.825 5.25 9 5.25C8.175 5.25 7.5 4.575 7.5 3.75C7.5 2.925 8.175 2.25 9 2.25ZM9 8.6625C7.23 7.0125 4.86 6 2.25 6V14.25C4.86 14.25 7.23 15.2625 9 16.9125C10.77 15.27 13.14 14.25 15.75 14.25V6C13.14 6 10.77 7.0125 9 8.6625ZM14.25 12.8475C12.3525 13.1025 10.5525 13.8225 9 14.9625C7.455 13.8225 5.6475 13.095 3.75 12.84V7.6275C5.325 7.9125 6.7875 8.64 7.98 9.75L9 10.71L10.02 9.7575C11.2125 8.6475 12.675 7.92 14.25 7.635V12.8475Z" fill="black" fillOpacity="0.54"/>
        </svg>
);
};
